import React, { useEffect, useLayoutEffect, useRef } from "react"
import GUI, { IGUIProps } from "../GUI"
import { TLineChartData, TChartLabel } from "./LineChartCanvas"
import LineChartCanvas from "./LineChartCanvas"
import Debounce from "../../libs/observer/Debounce"

export { type TLineChartData }
export type TLineChartProps = IGUIProps & {
    data:TLineChartData[]
    labelY?:TChartLabel
    value?:TChartLabel
}

export default function LineChart(props:TLineChartProps){
    const chart = useRef<LineChartCanvas|null>(null)
    const c = useRef<HTMLCanvasElement|null>(null)
    const debounce = useRef<Debounce<TLineChartData[]>|undefined>()

    const onMove = (e:React.PointerEvent<HTMLCanvasElement>) => chart.current?.hover(e)
    const onDown = (e:React.PointerEvent<HTMLCanvasElement>) => {
        e.currentTarget.setPointerCapture(e.pointerId)
        chart.current?.hover(e)
    }
    const onUp = (e:React.PointerEvent<HTMLCanvasElement>) => e.currentTarget.releasePointerCapture(e.pointerId)
    const onClear = () => chart.current?.clear()
    const onResize = () => debounce.current?.next(props.data)
    const onRefresh = (data:TLineChartData[]) => { if (c.current) chart.current = new LineChartCanvas(c.current, data, props.labelY, props.value) }

    useLayoutEffect(() => {
        if (!c.current) return
        const observer = new ResizeObserver(onResize)
        observer.observe(c.current)
        return () => {observer.disconnect()}
    },[])
    useEffect(() => {
        debounce.current = new Debounce(200)
        debounce.current.subscribe(onRefresh)
        debounce.current.next(props.data)
        return () => { debounce.current?.unsubscribe(onRefresh) }
    },[props.data])

    return <canvas ref={c} className={GUI.joinClass("linechart", props.className)} onPointerDown={onDown} onPointerUp={onUp} onPointerMove={onMove} onPointerLeave={onClear}/>
}